const UPLOAD_LOGO = 'upload-logo';
const CROP_LOGO = 'crop-logo';
const PREVIEW_LOGO = 'preview-logo';

const UPLOAD_LOGO_SCREEN = {
  upload: UPLOAD_LOGO,
  crop: CROP_LOGO,
  preview: PREVIEW_LOGO
};

export { UPLOAD_LOGO_SCREEN };
